export const getID = () => {
  return `_${(Math.random() * 10000000000).toFixed(0)}`
}

let THREE = {
  ...require('three'),
  ...require('three/examples/jsm/controls/OrbitControls.js'),
  ...require('three/examples/jsm/loaders/SVGLoader.js'),

  ...require('three/examples/jsm/controls/OrbitControls.js'),
  ...require('three/examples/jsm/postprocessing/EffectComposer.js'),
  ...require('three/examples/jsm/postprocessing/RenderPass.js'),
  ...require('three/examples/jsm/postprocessing/ShaderPass.js'),
  ...require('three/examples/jsm/postprocessing/UnrealBloomPass.js'),

  ...require('three/examples/jsm/misc/GPUComputationRenderer.js'),

  ...require('three/examples/jsm/loaders/FBXLoader.js')
}

export const glsl = require('glslify')

export const makeGPGPU = ({ renderer, parent, api }) => {
  var core = {}
  var WIDTH = 512
  var gpuCompute = new THREE.GPUComputationRenderer(WIDTH, WIDTH, renderer)

  // pos IDX
  var posIdx = gpuCompute.createTexture()
  var slot = posIdx.image.data
  var p = 0

  for (var j = 0; j < WIDTH; j++) {
    for (var i = 0; i < WIDTH; i++) {
      let id = p / 4
      slot[p + 0] = id % 6 // square 1 / 6 index
      slot[p + 1] = Math.floor(id / 6) // square
      slot[p + 2] = (WIDTH * WIDTH) / 6.0 // total
      slot[p + 3] = id
      p += 4
    }
  }

  // var velDynamic = gpuCompute.createTexture();
  var posDynamic = gpuCompute.createTexture()

  // var stateVar = gpuCompute.addVariable('tState', require('raw-loader!./tState.working-file.frag').default, stateDynamic );
  // stateVar.material.uniforms.tIdx = { value: posIdx };
  // stateVar.material.uniforms.time = { value: 0 };
  // stateVar.material.uniforms.mousePos = { value: new THREE.Vector3() }

  // var velVar = gpuCompute.addVariable('tVel', require('raw-loader!./tVel.working-file.frag').default, velDynamic );
  // velVar.material.uniforms.tIdx = { value: posIdx };
  // velVar.material.uniforms.time = { value: 0 };
  // velVar.material.uniforms.mousePos = { value: new THREE.Vector3() }
  // velVar.material.uniforms.screen = { value: new THREE.Vector3(window.innerWidth, window.innerHeight, 0.0) }

  var posVar = gpuCompute.addVariable('tPos', tPos, posDynamic)
  posVar.material.uniforms.tIdx = { value: posIdx }
  posVar.material.uniforms.time = { value: 0 }
  posVar.material.uniforms.mousePos = { value: new THREE.Vector3() }
  posVar.material.uniforms.screen = { value: new THREE.Vector3(window.innerWidth, window.innerHeight, 0.0) }

  // gpuCompute.setVariableDependencies( stateVar, [ stateVar, posVar, velVar ] )
  // gpuCompute.setVariableDependencies( velVar, [ posVar ] )
  gpuCompute.setVariableDependencies(posVar, [ posVar ])

  var error = gpuCompute.init()
  if (error !== null) {
    console.error(error)
  }

  var geo = new THREE.BufferGeometry()

  let getUVInfoForDisplayPosition = () => {
    let newArr = []
    var na = 0
    for (var j = 0; j < WIDTH; j++) {
      for (var i = 0; i < WIDTH; i++) {
        newArr[na + 0] = i / WIDTH
        newArr[na + 1] = j / WIDTH
        newArr[na + 2] = 0
        na += 3
      }
    }
    return newArr
  }

  geo.setAttribute('position', new THREE.Float32BufferAttribute(getUVInfoForDisplayPosition(), 3))
  geo.setAttribute('posIdx', new THREE.Float32BufferAttribute(posIdx.image.data, 4))

  var uniforms = {
    time: { value: 0 },
    tPos: { value: null }
  }
  var material = new THREE.ShaderMaterial({
    transparent: true,
    uniforms,
    defines: {
      resolution: `vec2(${renderer.domElement.width.toFixed(1)}, ${renderer.domElement.height.toFixed(1)})`
    },
    vertexShader: displayVert,
    fragmentShader: displayFrag,
    side: THREE.DoubleSide
  })

  var mesh = new THREE.Mesh(geo, material)
  parent.add(mesh)

  core.setMouse = ({ mX, mY, rect }) => {
    // var stateMouse = stateVar.material.uniforms.mousePos.value
    // var velMouse = velVar.material.uniforms.mousePos.value
    var mouser = posVar.material.uniforms.mousePos.value
    if (rect && typeof mX !== 'undefined' && typeof mY !== 'undefined') {
      // velMouse.x = ((mX - rect.left) / rect.width) * 2 - 1
      // velMouse.y = -((mY - rect.top) / rect.height) * 2 + 1
      mouser.x = ((mX - rect.left) / rect.width) * 2 - 1
      mouser.y = -((mY - rect.top) / rect.height) * 2 + 1
      // stateMouse.x = ((mX - rect.left) / rect.width) * 2 - 1
      // stateMouse.y = -((mY - rect.top) / rect.height) * 2 + 1

      // stateMouse.y *= rect.width / rect.height
      // velMouse.y *= rect.width / rect.height
      mouser.y *= rect.width / rect.height
      // console.log(mouse)
    }
  }

  api.loop(() => {
    let time = window.performance.now() * 0.001
    // stateVar.material.uniforms.time.value = time
    posVar.material.uniforms.time.value = time
    // velVar.material.uniforms.time.value = time

    uniforms.tPos.value = gpuCompute.getCurrentRenderTarget(posVar).texture
    uniforms.time.value = time
    gpuCompute.compute()
  })

  return api
}

export const setupBloomComposer = ({ renderer, scene, camera, api }) => {
  // var rID = getID()
  var gui = false
  var params = {
    exposure: 1,
    bloomThreshold: 0.63,
    bloomStrength: 4.35,
    bloomRadius: 0.8
  }

  let GUI = require('three/examples/jsm/libs/dat.gui.module.js').GUI
  gui = window.gui
  gui = gui || new GUI()
  window.gui = gui

  var folder = gui.addFolder('Bloom Parameters')
  folder.add(params, 'exposure', 0.1, 2).onChange(function (value) {
    renderer.toneMappingExposure = Math.pow(value, 4.0)
  })
  folder.add(params, 'bloomThreshold', 0.0, 1.0).onChange(function (value) {
    bloomPass.threshold = Number(value)
  })
  folder.add(params, 'bloomStrength', 0.0, 10.0).onChange(function (value) {
    bloomPass.strength = Number(value)
  })
  folder.add(params, 'bloomRadius', 0.0, 1.0).step(0.01).onChange(function (value) {
    bloomPass.radius = Number(value)
  })
  folder.open()
  if (window.innerWidth < 500) {
    folder.close()
  }

  api.cleanUp(() => {
    if (gui) {
      gui.destroy()
    }
  })

  // var ENTIRE_SCENE = 0
  // var BLOOM_SCENE = 1
  // var bloomLayer = new THREE.Layers()
  // bloomLayer.set(BLOOM_SCENE)

  var renderScene = new THREE.RenderPass(scene, camera)
  var bloomPass = new THREE.UnrealBloomPass(new THREE.Vector2(window.innerWidth * 2, window.innerHeight * 2), 1.5, 0.4, 0.85)
  bloomPass.threshold = params.bloomThreshold
  bloomPass.strength = params.bloomStrength
  bloomPass.radius = params.bloomRadius

  //   let flipPass = new THREE.ShaderPass({
  //     uniforms: {
  //       flip: { value: 1.0 },
  //       tDiffuse: { value: null },
  //       opacity: { value: 1.0 }
  //     },
  //     vertexShader: `
  // varying vec2 vUv;
  // void main() {
  // vUv = uv;
  // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  // }
  //     `,
  //     fragmentShader: `
  // uniform float opacity;
  // uniform float flip;
  // uniform sampler2D tDiffuse;
  // varying vec2 vUv;
  // void main() {
  // vec4 texel = texture2D( tDiffuse, vUv );

  // if (flip >= 0.0) {
  // gl_FragColor = vec4(flip - texel.rgb, opacity);
  // } else {
  // gl_FragColor = vec4(texel.rgb - 1.0 - flip, opacity);
  // }
  // }
  //     `
  //   })
  //   flipPass.renderToScreen = true
  //   flipPass.uniforms.flip = {
  //     get value () {
  //       return self.postProcessSettings.flipColor
  //     }
  //   }

  var bloomComposer = new THREE.EffectComposer(renderer)
  bloomComposer.renderToScreen = true
  bloomComposer.addPass(renderScene)
  bloomComposer.addPass(bloomPass)
  // bloomComposer.addPass(flipPass)

  return bloomComposer
}

export const setupControls = async ({ camera, renderer, api }) => {
  let control = new THREE.OrbitControls(camera, renderer.domElement)
  api.loop(() => {
    control.update()
  })
  api.cleanUp(() => {
  })
}

export const setupBase = async ({ api, mounter, vm }) => {
  let rID = getID()
  let exited = false
  let rect = mounter.getBoundingClientRect()

  let scene = new THREE.Scene()
  let camera = new THREE.PerspectiveCamera(75, rect.width / rect.height, 0.1, 1000)
  let renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true
  })
  let parent = new THREE.Object3D()

  // eslint-disable-next-line
  let env = {
    api,
    mounter,
    vm,
    get rect () {
      return rect
    },
    set rect (v) {
      rect = v
    },
    parent,
    camera,
    scene,
    renderer
  }

  renderer.setSize(rect.width, rect.height)
  renderer.setPixelRatio(window.devicePixelRatio > 1.5 ? window.devicePixelRatio : 1.5)
  mounter.appendChild(renderer.domElement)
  renderer.domElement.style.marginBottom = '-6px'

  window.addEventListener('resize', () => {
    if (exited) {
      return
    }
    rect = mounter.getBoundingClientRect()
    renderer.setSize(rect.width, rect.height)
    camera.aspect = rect.width / rect.height
    camera.updateProjectionMatrix()
  })

  setupControls({ ...env, camera, api, mounter })
  camera.position.z = 128

  // let camVideo = require('../GLService/cam-video.js').setup()

  makeGPGPU({ ...env, renderer, scene, api })
  scene.add(parent)

  let composer = setupBloomComposer({ renderer, scene, camera, api })
  var rAFID = 0
  var animate = function () {
    rAFID = requestAnimationFrame(animate)
    for (let kn in api.tasks) {
      api.tasks[kn]()
    }

    // camVideo.update()

    // renderer.render(scene, camera)

    if (composer) {
      composer.render()
    } else {
    }
  }

  api.teardown[rID] = () => {
    exited = true
    // console.log('clean')
    cancelAnimationFrame(rAFID)
    mounter.removeChild(renderer.domElement)
    renderer.dispose()
    scene.dispose()
  }

  animate()

  return api
}

export const install = async ({ mounter, vm }) => {
  let api = {
    loop (v) {
      api.tasks[Math.random() + '_'] = v
    },
    cleanUp (v) {
      api.teardown[Math.random() + '_'] = v
    },
    tasks: {},
    teardown: {}
  }

  api.clean = () => {
    for (let kn in api.tasks) {
      delete api.tasks[kn]
    }
    for (let kn in api.teardown) {
      api.teardown[kn]()
    }
  }

  await setupBase({ api, mounter, vm })

  return api
}

export const displayVert = glsl`
  #include <common>
  uniform highp sampler2D tPos;
  // uniform sampler2D tIdx;

  varying vec3 v_tt;

  void main() {
    // vec3 newPos = vec3(1.0);

    // position is changed to host uv vals
    vec4 tt = texture2D(tPos, position.xy);
    // vec4 idx = texture2D(tIdx, position.xy);

    v_tt = normalize(tt.xyz);

    vec4 mvPosition = modelViewMatrix * tt;
    vec4 outputPos = projectionMatrix * mvPosition;

    gl_Position = outputPos;
    // gl_PointSize = 1.0;
  }
`

export const displayFrag = glsl`
  #include <common>

  varying vec3 v_tt;

  void main() {
    gl_FragColor = vec4(
      0.25 + abs(v_tt.x),
      0.25 + abs(v_tt.y),
      0.25 + abs(v_tt.z),
      0.7
    );
  }
`

export const tPos = glsl`
precision highp float;
precision highp sampler2D;

uniform float time;
uniform sampler2D tIdx;

mat3 rotateX(float rad) {
    float c = cos(rad);
    float s = sin(rad);
    return mat3(
        1.0, 0.0, 0.0,
        0.0, c, s,
        0.0, -s, c
    );
}

mat3 rotateY(float rad) {
    float c = cos(rad);
    float s = sin(rad);
    return mat3(
        c, 0.0, -s,
        0.0, 1.0, 0.0,
        s, 0.0, c
    );
}

mat3 rotateZ(float rad) {
    float c = cos(rad);
    float s = sin(rad);
    return mat3(
        c, s, 0.0,
        -s, c, 0.0,
        0.0, 0.0, 1.0
    );
}

mat3 rotateQ (vec3 axis, float rad) {
    float hr = rad / 2.0;
    float s = sin( hr );
    vec4 q = vec4(axis * s, cos( hr ));
    vec3 q2 = q.xyz + q.xyz;
    vec3 qq2 = q.xyz * q2;
    vec2 qx = q.xx * q2.yz;
    float qy = q.y * q2.z;
    vec3 qw = q.w * q2.xyz;

    return mat3(
        1.0 - (qq2.y + qq2.z),  qx.x - qw.z,            qx.y + qw.y,
        qx.x + qw.z,            1.0 - (qq2.x + qq2.z),  qy - qw.x,
        qx.y - qw.y,            qy + qw.x,              1.0 - (qq2.x + qq2.y)
    );
}
const float PI = 3.1415926535897932384626433832795;
const float PI_2 = 1.57079632679489661923;
const float PI_4 = 0.785398163397448309616;

mat4 scale(float x, float y, float z){
    return mat4(
        vec4(x,   0.0, 0.0, 0.0),
        vec4(0.0, y,   0.0, 0.0),
        vec4(0.0, 0.0, z,   0.0),
        vec4(0.0, 0.0, 0.0, 1.0)
    );
}

mat4 translate(float x, float y, float z){
    return mat4(
        vec4(1.0, 0.0, 0.0, 0.0),
        vec4(0.0, 1.0, 0.0, 0.0),
        vec4(0.0, 0.0, 1.0, 0.0),
        vec4(x,   y,   z,   1.0)
    );
}

mat4 RotateX(float phi){
    return mat4(
        vec4(1.,0.,0.,0),
        vec4(0.,cos(phi),-sin(phi),0.),
        vec4(0.,sin(phi),cos(phi),0.),
        vec4(0.,0.,0.,1.));
}

mat4 RotateY(float theta){
    return mat4(
        vec4(cos(theta),0.,-sin(theta),0),
        vec4(0.,1.,0.,0.),
        vec4(sin(theta),0.,cos(theta),0.),
        vec4(0.,0.,0.,1.));
}

mat4 RotateZ(float psi){
    return mat4(
        vec4(cos(psi),-sin(psi),0.,0),
        vec4(sin(psi),cos(psi),0.,0.),
        vec4(0.,0.,1.,0.),
        vec4(0.,0.,0.,1.));
}
struct Square {
  float xID;
  float yID;
  float xSize;
  float ySize;
  bool shouldSkipRender;
  vec4 vertex;
};

Square assembleSquaresIntoPlane (vec2 plane, vec2 gap)  {
  bool shouldSkipRender = false;
  vec2 cellSize = 1.0 / resolution.xy;
  vec2 newCell = gl_FragCoord.xy;
  vec2 uv = newCell * cellSize;
  vec4 oldPos = texture2D(tPos, uv);
  vec4 idx = texture2D(tIdx, uv);

  float vertexID = idx.w;
  float squareVertexID = idx.x;
  float squareIDX = idx.y;
  float totalPoints = idx.z;

  vec4 pos = vec4(0.0);
  float dimension = 368.0;
  float stackIDX = floor(squareIDX / dimension);
  float lineIDX = mod(squareIDX, dimension);
  if (lineIDX > dimension) {
    shouldSkipRender = true;
  }
  if (stackIDX > dimension) {
    shouldSkipRender = true;
  }

  float planeWidth = plane.x;
  float planeHeight = plane.y;

  float w = planeWidth * (2.0 + gap.x);
  float h = planeHeight * (2.0 + gap.y);

  float offsetX = (w * lineIDX) - (w * dimension * 0.5);
  float offsetY = (h * stackIDX) - (h * dimension * 0.5);
  vec3 offsetXYZ = vec3(offsetX, offsetY, 0.0);

  if (squareVertexID == 0.0) {
    pos.x = 1.0 * planeWidth;
    pos.y = 1.0 * planeHeight;
    pos.z = 0.0;
  } else if (squareVertexID == 1.0) {
    pos.x = -1.0 * planeWidth;
    pos.y = 1.0 * planeHeight;
    pos.z = 0.0;
  } else if (squareVertexID == 2.0) {
    pos.x = -1.0 * planeWidth;
    pos.y = -1.0 * planeHeight;
    pos.z = 0.0;
  } else if (squareVertexID == 3.0) {
    pos.x = 1.0 * planeWidth;
    pos.y = 1.0 * planeHeight;
    pos.z = 0.0;
  } else if (squareVertexID == 4.0) {
    pos.x = -1.0 * planeWidth;
    pos.y = -1.0 * planeHeight;
    pos.z = 0.0;
  } else if (squareVertexID == 5.0) {
    pos.x = 1.0 * planeWidth;
    pos.y = -1.0 * planeHeight;
    pos.z = 0.0;
  } else {
    shouldSkipRender = true;
  }

  pos.xyz += offsetXYZ;

  Square square = Square(lineIDX, stackIDX, dimension, dimension, shouldSkipRender, pos);

  return square;
}

void main () {
  //------ START READING ME --------
  vec2 planeSize = vec2(
    0.12345, // width
    0.12345 // height
  );
  vec2 gapSize = vec2(
    0.0, // x Gap
    0.0 // y Gap
  );

  Square info = assembleSquaresIntoPlane(planeSize, gapSize);
  float xID = info.yID;
  float yID = info.xID;
  float xSize = info.xSize;
  float ySize = info.ySize;
  vec4 pos = info.vertex;
  bool shouldSkipRender = info.shouldSkipRender;

  // go crazy
  float pX = pos.x;
  float pY = pos.y;
  float pZ = pos.z;
  float piz = 0.01 * 2.0 * 3.14159265;

  pos.xyz *= rotateQ(normalize(vec3(1.0, sin(time), 1.0)), time + pX * pY * piz * piz);

  // ------ STOP READING ME ------

  if (shouldSkipRender) {
    discard;
    return;
  } else {
    pos.w = 1.0;
    gl_FragColor = pos;
  }
}

`
